import {AgentInformation} from 'ApplicationEntry/models/AgentInformation';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

import * as I from 'immutable';

export class InvalidAgentList {
  public readonly key = 'InvalidAgentList';

  constructor(public readonly agentList: I.List<AgentInformation>) {}
}

export class ValidAgentList {
  public static create(agentList: I.List<AgentInformation>) {
    const agentListArrayLength = agentList.size;
    const haveAtLeastOneAgent = agentListArrayLength > 0;

    return haveAtLeastOneAgent ? new ValidAgentList(agentList) : new InvalidAgentList(agentList);
  }

  public readonly key = 'ValidAgentList';
  private constructor(public readonly agentList: I.List<AgentInformation>) {}
}

export type AgentList = InvalidAgentList | ValidAgentList;

export type agentListOptions<TReturn> = ToPartialMatchOptions<AgentList, 'key', TReturn>;

export const matchAgentList = <TReturn>(options: agentListOptions<TReturn>) => (app: AgentList): TReturn => {
  switch (app.key) {
    case 'InvalidAgentList':
      return options.InvalidAgentList ? options.InvalidAgentList(app) : options.default(app);
    case 'ValidAgentList':
      return options.ValidAgentList ? options.ValidAgentList(app) : options.default(app);
  }
};

export const addAgent = (agent: AgentInformation) => (agentList: I.List<AgentInformation>) => {
  const existingList: I.List<AgentInformation> = agentList;
  const newAgentList = existingList.concat(agent);

  return ValidAgentList.create(newAgentList);
};

export const removeAgent = (index: number) => (agentList: I.List<AgentInformation>) => {
  const existingList: I.List<AgentInformation> = agentList;
  const newAgentList = existingList.delete(index);

  return ValidAgentList.create(newAgentList);
};

export const removeAgents = (agents: I.List<AgentInformation>) => (agentList: I.List<AgentInformation>) => {
  const existingList: I.List<AgentInformation> = agentList;
  const newAgentList = existingList.filter(agent => !agents.includes(agent)).toArray();

  return ValidAgentList.create(I.List<AgentInformation>(newAgentList));
};

export const updateAgent = (agent: AgentInformation, index: number) => (agentList: I.List<AgentInformation>) => {
  const existingList: I.List<AgentInformation> = agentList;
  let newAgentList: I.List<AgentInformation> = existingList;

  newAgentList = existingList.splice(index, 1, agent);

  return ValidAgentList.create(newAgentList);
};

export const EmptyAgentList = new InvalidAgentList(I.List<AgentInformation>());
